

























import { Vue, Component } from 'vue-property-decorator';
import { RootState } from '@/store';
import { State } from 'vuex-class';
import { DataSettings, DataListItem, DataViewItem, VueOptions } from '@/types';
import { DataManagementState } from '@/store/modules/dataManagement';
import { findInDataByRegisterId } from '@/utils/statementObjectData';
import { navigationQueryName } from '@/utils';
import { getCurrentDate } from '@/utils/date';
import VueRouter from 'vue-router';
import route from '@/router';

@Component({
  name: 'app-breadcrumbs',
  getCurrentDate,
} as VueOptions)
export default class extends Vue {

  @State((state: RootState) => state.dataManagement.settings.report_title)
  private reportTitle!: DataSettings['report_title'];

  @State((state: RootState) => state.dataManagement.content)
  private allDataContent!: DataListItem[] & DataManagementState['content'];

  @State((state: RootState) => state.dataManagement.content)
  private rootDataList!: DataListItem[] & DataManagementState['content'];

  @State((state: RootState) => state.dataManagement.navigatedListIndexes)
  private navigatedListIndexes!: string[];

  @State((state: RootState) => state.dataManagement.navigatedLists)
  private navigatedLists!: Array<DataListItem | DataListItem[]>;

  @State((state: RootState) => state.dataManagement.iframeUrlQuery)
  private iframeUrlQuery!: string;

  @State((state: RootState) => state.dataManagement.registerParentListItem)
  private registerParentListItem!: DataListItem;

  private get breadcrumbs(): string[] {
    const crumbs: string[] = [this.reportTitle];

    if (this.allDataContent.length) {
      const registerId = Number((this.iframeUrlQuery.split(navigationQueryName)[1] || '').replace('=', ''));
      const register: DataViewItem | DataListItem | undefined = findInDataByRegisterId(registerId || 0, this.allDataContent);
      const dataListItemTitle: DataListItem['title'] | DataViewItem['title'] = (register && this.registerParentListItem.title)
        ? this.registerParentListItem.title
        : this.getDataListItemByNavigatedListIndexes() && ((this.navigatedLists[0] || {}) as DataListItem).title;

      if (dataListItemTitle) {
        crumbs.push(dataListItemTitle);
      }
    }

    return crumbs;
  }

  private getDataListItemByNavigatedListIndexes(): DataListItem {
    let currentList: DataListItem[] = this.rootDataList;
    let currentDataItem: DataListItem = {} as DataListItem;
    this.navigatedListIndexes.forEach((index: string, i) => {
      const listIndex: number = Number(index.split('-')[1]);
      if (i === this.navigatedListIndexes.length - 1) {
        currentDataItem = (currentList || [])[listIndex] as DataListItem;
        this.$store.commit('dataManagement/SET_NAVIGATED_LISTS', currentDataItem);
      } else {
        currentList = (currentList[listIndex] || {}).children as DataListItem[];
        this.$store.commit('dataManagement/SET_NAVIGATED_LISTS', currentList);
      }
    });

    return currentDataItem;
  }

  private get showAll(): boolean {
    // @ts-ignore
    return (route as VueRouter).history!.current!.query.showAll === 'true';
  }
}
